import React from "react";
import FuelTransactionsView from "../components/FuelTransactionsView";

// The review worklist: the same table as Fuel Transactions, pinned to
// purchases that raised at least one fuel exception and opening on the ones
// still waiting for someone to look at them.
const FuelExceptionsPage = () => (
  <FuelTransactionsView
    exceptionsMode
    title="Fuel Exceptions"
    subtitle="Purchases that need a second look - open one to compare the entry with its photos, then mark it reviewed or void it"
  />
);

export default FuelExceptionsPage;
